<template>
  <div class="mainBox">
    <!-- 列表 -->
    <a-calendar
      v-model:value="dateValue"
      @panelChange="panelChangeFun"
      :locale="locale"
    >
      <template #dateCellRender="{ current }">
        <ul class="events">
          <li v-for="item in setData(current)" :key="item.id">
            <span
              v-if="item.isLogin"
              class="ksTitle colorStr"
              :class="
                item.appointmentType.indexOf('2') == -1
                  ? 'ksTitle'
                  : 'ksTitle ksTitleColor'
              "
              @click="bmExam(item)"
              :title="item.subjectName+'  '+item.examStartTime+'至'+item.examEndTime"
              >{{ item.subjectName }}
              <span v-if="item.appointmentType.indexOf('2') != -1">（内部考试）</span>
              <span v-if="item.appointmentType.indexOf('2') == -1">（外部考试）</span>
              </span
            ><span
              v-if="!item.isLogin"
              class="ksTitle"
              :class="
                item.appointmentType.indexOf('2') == -1
                  ? 'ksTitle'
                  : 'ksTitle ksTitleColor'
              "
              @click="bmExam(item)"
              :title="item.subjectName+'  '+item.examStartTime+'至'+item.examEndTime"
              >{{ item.subjectName }}
              <span v-if="item.appointmentType.indexOf('2') != -1">（内部考试）</span>
              <span v-if="item.appointmentType.indexOf('2') == -1">（外部考试）</span>
              </span
            ><span
              v-if="item.isLogin"
              class="eyeBtn"
              title="查看报名情况"
              @click="examinationSignUp(item)"
              ><EyeOutlined
            /></span>
          </li>
        </ul>
      </template>
    </a-calendar>
    <!-- 报名考试弹窗 -->
    <a-modal
      v-model:visible="visible"
      width="700px"
      title="报名考试"
      :footer="null"
      :closable="closable"
    >
      <a-form :model="formObj" :rules="rules" ref="infoForm">
        <a-form-item
          label="预约类型"
          name="appointmentType"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-radio-group v-model:value="formObj.appointmentType">
            <a-radio v-for="(item,index) in appointmentTypeArr" :key="item.value" :value="item.value">{{item.text}}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="姓名"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="appointmentName"
        >
          <a-input v-model:value="formObj.appointmentName" />
        </a-form-item>
        <a-form-item
          label="身份证号"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="cardNumber"
          v-if="
            formObj.appointmentType == '2' || formObj.appointmentType == '3'
          "
        >
          <a-input v-model:value="formObj.cardNumber" />
        </a-form-item>
        <a-form-item
          v-if="
            formObj.appointmentType == '0' || formObj.appointmentType == '2'
          "
          label="工号"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="workCode"
        >
          <a-input v-model:value="formObj.workCode" />
        </a-form-item>
        <a-form-item
          label="单位"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="unit"
          v-if="formObj.appointmentType != '2'"
        >
          <a-input v-model:value="formObj.unit" />
        </a-form-item>
        <a-form-item
          label="部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="depart"
          v-if="formObj.appointmentType != '2'"
        >
          <a-input v-model:value="formObj.depart" />
        </a-form-item>
        <a-form-item
          v-if="formObj.appointmentType == '2'"
          label="一级部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="firstDepartment"
        >
          <a-input v-model:value="formObj.firstDepartment" />
        </a-form-item>
        <a-form-item
          v-if="formObj.appointmentType == '2'"
          label="二级部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="secondDepartment"
        >
          <a-input v-model:value="formObj.secondDepartment" />
        </a-form-item>
        <a-form-item
          v-if="formObj.appointmentType == '2'"
          label="三级部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="thirdDepartment"
        >
          <a-input v-model:value="formObj.thirdDepartment" />
        </a-form-item>
        <a-form-item
          v-if="formObj.appointmentType == '2'"
          label="四级部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="fourDepartment"
        >
          <a-input v-model:value="formObj.fourDepartment" />
        </a-form-item>
        <a-form-item
          v-if="formObj.appointmentType == '2'"
          label="职场"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="workPlace"
        >
          <a-input v-model:value="formObj.workPlace" />
        </a-form-item>
        <a-form-item
          label="邮箱"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="mail"
        >
          <a-input v-model:value="formObj.mail" />
        </a-form-item>
        <a-form-item
          label="手机号"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="mobile"
        >
          <a-input v-model:value="formObj.mobile" />
        </a-form-item>
        <a-form-item
          label="考试人数"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="
            formObj.appointmentType == '0' || formObj.appointmentType == '1'
          "
        >
          <a-input-number
            v-model:value="formObj.examCount"
            :min="1"
            :max="1000000"
          />
        </a-form-item>
        <a-form-item
          label="证书类型"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-radio-group v-model:value="formObj.certificateType">
            <a-radio value="0">统信认证</a-radio>
            <a-radio value="1">工信人才联合认证</a-radio>
            <a-radio value="2">其他</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="其他证书描述"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="formObj.certificateType == '2'"
        >
          <a-textarea
            v-model:value="formObj.certificateOther"
            placeholder="请输入其他证书描述信息"
            :auto-size="{ minRows: 2, maxRows: 5 }"
            :maxlength="500"
          />
        </a-form-item>
        <a-form-item
          label="费用类型"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="formObj.appointmentType != 2"
        >
          <a-radio-group v-model:value="formObj.feeType">
            <!-- <a-radio value="0">内部核算</a-radio> -->
            <a-radio value="1">直销</a-radio>
            <!-- <a-radio value="2">免费</a-radio> -->
            <a-radio value="3">代理商</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="费用价格"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="
            (formObj.feeType == '2' || formObj.feeType == '3') &&
              formObj.appointmentType != 2
          "
        >
          <a-input-number
            v-model:value="formObj.fee"
            :min="0"
            :max="100000000"
          />
        </a-form-item>
        <a-form-item
          label="教培代理商级别"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="formObj.appointmentType == '1' && formObj.feeType=='3'"
        >
          <a-radio-group v-model:value="formObj.agentLevel">
            <a-radio value="0">钻石</a-radio>
            <a-radio value="1">金牌</a-radio>
            <a-radio value="2">银牌</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="所在省市"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          v-if="
            formObj.appointmentType == '1' || formObj.appointmentType == '3'
          "
        >
          <a-select
            v-model:value="provinceStr"
            style="width: 160px"
            :options="
              provinceData.map((pro) => ({
                value: pro.provinceId,
                label: pro.name,
              }))
            "
          >
          </a-select>
          <a-select
            v-model:value="formObj.city"
            style="width: 160px"
            :options="cities"
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label="对接人姓名"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="contactName"
          v-if="formObj.appointmentType == '1'"
        >
          <a-input v-model:value="formObj.contactName" />
        </a-form-item>
        <a-form-item
          label="对接人部门"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="contactUnit"
          v-if="formObj.appointmentType == '1'"
        >
          <a-input v-model:value="formObj.contactUnit" />
        </a-form-item>
        <a-form-item
          label="报名来源"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
          name="appointmentSource"
          v-if="formObj.appointmentType == '3'"
        >
          <a-input v-model:value="formObj.appointmentSource" />
        </a-form-item>
        <a-form-item
          label="学员认证考试报名表模板"
          :label-col="{ span: 6, offset: 0 }"
          :wrapper-col="{ span: 16 }"
          v-if="
            formObj.appointmentType == '0' || formObj.appointmentType == '1'
          "
        >
          <a-button @click="downFile" type="primary" :loading="btnLoading"
            ><VerticalAlignBottomOutlined
          /></a-button>
        </a-form-item>
        <a-form-item
          label="上传学员认证考试报名表"
          :label-col="{ span: 6, offset: 0 }"
          :wrapper-col="{ span: 16 }"
          v-if="
            formObj.appointmentType == '0' || formObj.appointmentType == '1'
          "
        >
          <a-upload
            :file-list="fileList"
            :customRequest="customRequestZip"
            :before-upload="beforeUploadZip"
            :remove="removeFile"
            name="name"
          >
            <!-- <div class="ant-upload-text" v-if="fileList.length==0">上传考试模板</div> -->

            <a-button type="primary" :loading="loadingBtnFile"
              ><VerticalAlignTopOutlined
            /></a-button>
            <!-- <UploadOutlined /> -->
          </a-upload>
        </a-form-item>
        <a-form-item
          label="备注"
          :label-col="{ span: 5, offset: 0 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-textarea
            v-model:value="formObj.remark"
            placeholder="请输入备注信息"
            :auto-size="{ minRows: 2, maxRows: 5 }"
            :maxlength="500"
          />
        </a-form-item>
        <a-form-item
          :wrapper-col="{ span: 14, offset: 4 }"
          style="text-align:center;"
        >
          <a-button
            style="margin-right: 10px"
            @click="resetForm"
            :disabled="loadingBtn"
            >取消</a-button
          >
          <a-button type="primary" @click="onSubmit" :loading="loadingBtn"
            >保存</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 考试人员列表 -->
    <a-modal
      v-model:visible="visibleTable"
      width="1200px"
      title="考试报名人员信息"
      :footer="null"
    >
      <a-form :model="listQuery" layout="inline" style="margin-bottom:20px;">
        <a-form-item label="姓名">
          <a-input v-model:value="listQuery.name" allowClear />
        </a-form-item>
        <a-form-item label="身份证">
          <a-input v-model:value="listQuery.idCard" allowClear />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">
            查询
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="onReset"> 重置 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="handleAllDel"> 批量删除 </a-button>
        </a-form-item>
      </a-form>
      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="pagination"
        @change="changeUserTable"
      />
    </a-modal>
  </div>
</template>
<script>
import { loginParams } from "../../common/query";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import moment from'moment';
import { createVNode, created, mounted, h } from "vue";
import { Modal, message, notification } from "ant-design-vue";
import 'moment/dist/locale/zh-cn';
export default {
  name: "",
  props: {},
  data() {
    moment.locale('zh-cn');
      // 邮箱验证
    const validateEmail=(rule, value)=>{
      const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value == "") return Promise.reject("请输入邮箱");
      else if (!reg.test(value)) {
        return Promise.reject("邮箱格式不正确");
      } else {
        return Promise.resolve();
      }
    };
    const checkWorkCode=(rule,value)=>{
        const reg = /^[u|U][t|T]\d{6}$/;
        if (value == "") return Promise.reject("请输入工号");
        else if (!reg.test(value)) {
            return Promise.reject("请输入正确的工号格式，例如：UT000001");
        } else {
            return Promise.resolve();
        }
    }
    return {
      closable:false,
      loadingBtn:false,
      loadingBtnFile:false,
      appointmentTypeArr:[],
      columns:[
        {
          title: '姓名',
          dataIndex: 'appointmentName',
        },
        {
          title: '身份证',
          dataIndex: 'cardNumber',
        },
        {
          title: '城市',
          dataIndex: 'city',
        },
        {
          title: '考点名称',
          dataIndex: 'examRoom',
        },
        {
          title: '科目',
          dataIndex: 'examSubject',
        },
        {
          title: '代理类型',
          dataIndex: 'agentLevel',
        },
        {
          title: '责任销售',
          dataIndex: 'saleName',
        },
        {
          title: '认证类型',
          dataIndex: 'authType',
        },
        {
          title: '考试日期',
          dataIndex: 'examTime',
        },
        {
          title: '考试时间段',
          dataIndex: 'timePeriod',
        },
      ],
      tableData:[],
      listQuery:{
        pageSize:10,
        pageIndex:1,
        name:'',
        idCard:'',
        exam_id:''
      },
      pagination:{
        total: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      selectedRowKeys:[],
      visibleTable:false,
      rules:{
        appointmentName: [ { required: true, message: '姓名不能为空', trigger: 'blur' }, ],
        firstDepartment: [ { required: true, message: '一级部门不能为空', trigger: 'blur' }, ],
        secondDepartment: [ { required: true, message: '二级部门不能为空', trigger: 'blur' }, ],
        workPlace: [ { required: true, message: '职场不能为空', trigger: 'blur' }, ],
        workCode: [  { required: true,validator: checkWorkCode, trigger: 'blur' }, ],
        unit: [ { required: true, message: '单位不能为空', trigger: 'blur' }, ],
        depart: [ { required: true, message: '部门不能为空', trigger: 'blur' }, ],
        mail: [ { required: true,  validator: validateEmail, trigger: "blur" } ],
        mobile: [  { required: true,pattern: "^1(3([0-35-9]\\d|4[1-8])|4[14-9]\\d|5([0-35689]\\d|7[1-79])|66\\d|7[2-35-8]\\d|8\\d{2}|9[13589]\\d)\\d{7}$", message: "请输入正确的手机号", trigger: "blur" } ],
        contactName: [ { required: true, message: '对接人姓名不能为空', trigger: 'blur' }, ],
        contactUnit: [ { required: true, message: '对接人部门不能为空', trigger: 'blur' }, ],
        appointmentSource: [ { required: true, message: '预约来源不能为空', trigger: 'blur' }, ],
        cardNumber: [ {  required: true, pattern: "^[1-9]\\d{5}(18|19|20|(3\\d))\\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$",  message: "请输入正确格式身份证号", trigger: "change" } ]
      },
      localStorageUserInfo:localStorage.getItem('userinfo'),
      dateValue:"",
      locale,
      listData1:[],
      btnLoading:false,
      pagination: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
      monthStartDay: "",
      monthEndDay: "",
      provinceData:[],
      provinceStr:'',
      cityData:null,
      queryList: {
        startTime: "",
        endTime: "",
        userId:''
      },
      userinfo: null,
      visible: false,
      formObj: {
        id: "",
        appointmentType: '0', //预约类型 0-销售 1-代理商 2-员工 3-个人',
        appointmentName: "", //申请人姓名',
        workCode: "", //申请人工号',
        unit: "", //申请人单位',
        depart: "", //,申请人部门',
        firstDepartment: "",//一级部门
        secondDepartment: "",//二级部门
        thirdDepartment: "",//三级部门
        fourDepartment: "",//四级部门
        workPlace: "",//职场
        mail: "", //申请人邮箱',
        mobile: "", //申请人手机号',
        examCount: "1", //考试人数',
        examId: "", //考试id',
        certificateType: "0", //证书类型（0统信认证/1工信人才联合认证/2其他（点其他，可以自己填写证书类别））',
        certificateOther: "", //证书类型其他（0统信认证/1工信人才联合认证/2其他（点其他，可以自己填写证书类别））',
        feeType: "3", //费用类型（0-内部核算 1-直销 2-免费 3-代理商）',
        fee: "0", //费用价格',
        appointmentDate: "", //申请日期',
        fileId: "", //附件上传阿里云文件id',
        remark: "", //备注',
        agentLevel: "0", //代理商级别 0-钻石、1-金牌、2-银牌',
        province: "", //'省份',
        city: "", //市',
        contactName: "", //代理商对接人姓名',
        contactUnit: "", //代理商对接人部门',
        appointmentSource: "", //个人报名预约来源',
        cardNumber:'',//省份证号
      },
      cities:null,
      imgUrl:[],
      acceptTypeEquipZip:["xls", "xlsx"],
      fileImgList: [],
      fileList:[],
      fileCode:"",
    };
  },
  // computed: {
  //     cities(){
  //         console.log('this.cityData[this.formObj.province]',this.cityData[this.formObj.province]);
  //         if(this.formObj.province==''){
  //             return await this.cityData[this.provinceData[0].provinceId].map(ct=>({ value: ct.cityId,label:ct.name }));
  //         }else{
  //           return await this.cityData[this.provinceStr].map(ct=>({ value: ct.cityId,label:ct.name }));
  //         }
  //     },
  //     // localStorageUserInfo(){
  //     //   console.log('computer:',localStorage.getItem('userinfo'));
  //     //   return localStorage.getItem('userinfo')
  //     // }
  // },
  computed:{
    localStorageUserInfo(){
      console.log('computer:',localStorage.getItem('userinfo'));
      return localStorage.getItem('userinfo')
    }
  },
   watch: {
      provinceStr:async function(newVal,oldVal){
          if(newVal!=''){
             await this.queryCity(newVal)
            //  setTimeout(() => {
            this.cities =   this.cityData[newVal].map(ct=>({ value: ct.cityId,label:ct.name }));
            console.log('city:',this.cities);
            // this.formObj.city=''
            if(this.cities && this.cities.length>0){
                this.formObj.city = this.cities[0].value
            }else{
              this.formObj.city = ""
            }
            console.log('this.formObj.city:',this.formObj.city);
            //  }, 1000);
          }
      },
      localStorageUserInfo:function (newVal,oldVal) {
        console.log('localStorage:',newVal,oldVal);
      },
  },
  async created() {
  console.log('sssss',this.month);
    await this.queryProvince()
    await this.queryCity(this.provinceData[0].provinceId)
    this.cities =   this.cityData[this.provinceData[0].provinceId].map(ct=>({ value: ct.cityId,label:ct.name }));
    this.formObj.city=''
    let startYear = this.year
    let endYear=this.year
    if(this.cities&&this.cities.length>0){
        this.formObj.city = this.cities[0].value
    }
    this.userinfo = localStorage.getItem("userinfo")
      ? JSON.parse(localStorage.getItem("userinfo"))
      : null;
    let startMonth = "";
    if (this.month > 1) {
      startMonth =
        this.month - 1 < 10 ? "0" + (this.month - 1) : this.month - 1;
    } else {
      startMonth = 12;
      startYear = this.year - 1;
    }
    let endMonth = "";
    if (this.month < 12) {
      endMonth = this.month + 1 < 10 ? "0" + (this.month + 1) : this.month + 1;
    } else {
      endMonth = "01";
      endYear = this.year + 1;
    }
    this.monthStartDay = startYear + "-" + startMonth + "-15";
    // this.monthStartDay = this.year + "-05" + "-15";
    this.monthEndDay = endYear + "-" + endMonth + "-15";
    this.queryList.startTime = this.monthStartDay;
    this.queryList.endTime = this.monthEndDay;
    await this.getListData()
  },
  methods: {
    handleSearch(){
      this.listQuery.pageIndex = 1
      this.pagination.pageIndex=1
      this.getUserList()
    },
    onReset(){
      this.listQuery={
        pageSize:10,
        pageIndex:1,
        name:'',
        idCard:''
      }
    },
    handleAllDel(){
      if(this.selectedRowKeys &&this.selectedRowKeys.length>0){
        const _this = this
      Modal.confirm({
          title: "确认删除",
          icon: createVNode(ExclamationCircleOutlined),
          content: "删除操作不可撤销，请谨慎操作。",
          okText: "确定",
          cancelText: "取消",
          async onOk() {
            const ids = _this.selectedRowKeys.join(',')
            _this.$store.dispatch('DeleteUserByStatusExam', {ids:ids,exam_id:_this.listQuery.exam_id}).then(res=>{
              if(res.data.code==0){
                _this.$message.success('删除成功')
                _this.getUserList()
              }else{
                _this.$message.error(res.data.msg)
              }
            }).catch(err=>{
              _this.$message.error(err)
            })
          }
        });
      }else{
        this.$message.warning('请先选择数据，在进行删除操作！！')
      }
    },
    handleDel(row){
      console.log('row:',row);
    },
    onSelectChange(row){
      console.log(row);
      this.selectedRowKeys = row
    },
    examinationSignUp(item){
      this.listQuery.exam_id = item.id
      this.visibleTable = true
      this.getUserList()
    },
    getUserList(){
      this.$store.dispatch('UserListExam', this.listQuery).then(res=>{
        if(res.data.code==0){
          this.tableData = res.data.data.list
          this.pagination.total=res.data.data.totalCount
          this.pagination.pageIndex=res.data.data.currPage
          this.pagination.pageSize=res.data.data.pageSize
        }else{
          this.$message.error(res.data.msg)
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    changeUserTable(page){
      // console.log(page);
      this.listQuery.pageIndex = page.current
      this.getUserList()
    },
    temp(){
      this.formObj= {
        id: "",
        appointmentType: '0', //预约类型 0-销售 1-代理商 2-员工 4-个人',
        appointmentName: "", //申请人姓名',
        workCode: "", //申请人工号',
        firstDepartment: "",//一级部门
        secondDepartment: "",//二级部门
        thirdDepartment: "",//三级部门
        fourDepartment: "",//四级部门
        workPlace: "",//职场
        unit: "", //申请人单位',
        depart: "", //,申请人部门',
        mail: "", //申请人邮箱',
        mobile: "", //申请人手机号',
        examCount: "1", //考试人数',
        examId: "", //考试id',
        certificateType: "0", //证书类型（0统信认证/1工信人才联合认证/2其他（点其他，可以自己填写证书类别））',
        certificateOther: "", //证书类型其他（0统信认证/1工信人才联合认证/2其他（点其他，可以自己填写证书类别））',
        feeType: "3", //费用类型（0-内部核算 1-直销 2-免费 3-代理商）',
        fee: "0", //费用价格',
        appointmentDate: "", //申请日期',
        fileId: "", //附件上传阿里云文件id',
        remark: "", //备注',
        agentLevel: "0", //代理商级别 0-钻石、1-金牌、2-银牌',
        province: "", //'省份',
        city: "", //市',
        contactName: "", //代理商对接人姓名',
        contactUnit: "", //代理商对接人部门',
        appointmentSource: "", //个人报名预约来源',
        cardNumber:'',//省份证号
      }
    },
    resetForm(){
      this.temp()
      this.visible = false
      this.$refs.infoForm.resetFields();
    },
    onSubmit(){
      this.loadingBtn = true
      if (this.formObj.appointmentType==1 || this.formObj.appointmentType==3) {
        this.formObj.workCode =''
      }
      if (this.formObj.appointmentType==2 || this.formObj.appointmentType==3) {
        this.formObj.examCount =''
      }
      if (this.formObj.appointmentType==0 ||this.formObj.appointmentType==2 || this.formObj.appointmentType==3) {
        this.formObj.agentLevel =''
        this.formObj.contactName =''
        this.formObj.contactUnit =''
      }
      if (this.formObj.appointmentType==0 || this.formObj.appointmentType==1) {
        this.formObj.cardNumber =''
      }
      if (this.formObj.appointmentType==0 || this.formObj.appointmentType==2) {
        this.formObj.province =''
        this.formObj.fee ='0'
      }
      if (this.formObj.appointmentType==0 ||this.formObj.appointmentType==1 || this.formObj.appointmentType==2) {
        // this.formObj.city =''
        this.formObj.appointmentSource =''
      }
      if(this.formObj.appointmentType != 0 && this.formObj.appointmentType!=1){
        this.formObj.fileId=''
      }
      console.log('this.formObj:',this.formObj);
      let token = localStorage.getItem('token')
      let funStr =''
      if(this.formObj.id ==''){
        funStr="SaveExam"
      }else{
        funStr="UpdateExam"
      }
      this.formObj.province = this.provinceStr
      const formObjObj = Object.assign({},this.formObj)
      // formObjObj.token = token
      this.$refs.infoForm.validate().then(()=>{
        this.$store.dispatch(funStr, formObjObj).then(res=>{
          if(res.status == 200){
            if(res.data.code==0){
              this.$message.success('报名成功')
              this.visible=false
            }else{
              this.$message.error(res.data.msg)
            }
            this.loadingBtn = false
            this.getListData();
          }
        }).catch(err=>{
          this.$message.error(err)
          this.visible=false
          this.loadingBtn = false
        })
      }).catch(er=>{
        console.log(er);
        this.loadingBtn = false
      })

    },
    panelChangeFun(value) {
      const selectDay = value.format("YYYY-MM-DD");
      const selectMonth = new Date(selectDay).getMonth() + 1;
      let selectStartYear = new Date(selectDay).getFullYear();
      let selectEndYear = new Date(selectDay).getFullYear();
      let startMonth = "";
      if (selectMonth > 1) {
        startMonth =
          selectMonth - 1 < 10 ? "0" + (selectMonth - 1) : selectMonth - 1;
      } else {
        startMonth = 12;
        selectStartYear = selectStartYear - 1;
      }
      let endMonth = "";
      if (selectMonth < 12) {
        endMonth =
          selectMonth + 1 < 10 ? "0" + (selectMonth + 1) : selectMonth + 1;
      } else {
        endMonth = "01";
        selectEndYear = selectEndYear + 1;
      }
      this.monthStartDay = selectStartYear + "-" + startMonth + "-15";
      this.monthEndDay = selectEndYear + "-" + endMonth + "-15";
      this.queryList.startTime = this.monthStartDay;
      this.queryList.endTime = this.monthEndDay;
      this.getListData();
    },
    setData(value) {
      const listData = [];
      if (this.listData1.length == 0) {
        return [];
      } else {
        this.listData1.forEach((item) => {
          if (item.examStartTime.indexOf(value.format("YYYY-MM-DD")) != -1) {
            listData.push(item);
          }
        });
        return listData;
      }
    },
    async getListData() {
      console.log('userinfo',localStorage.getItem('userinfo'))
      if(localStorage.getItem('userinfo')){
        this.queryList.userId = JSON.parse(localStorage.getItem('userinfo')).id
      }else{
        this.queryList.userId = null
      }
      await this.$store
        .dispatch("RlSelectList", this.queryList)
        .then((res) => {
          if (res.data.code === 0) {
            this.listData1 = res.data.data;
            console.log('getListData:',this.listData1);
          } else {
            console.log('res:',res);
          }
        })
        .catch((err) => {
          console.log('err:',err)
        });
    },
    // 考试报名
    bmExam(item) {
      if(this.userinfo == null){
          this.$message.warning('请先登录，再报名！')
      }else{
        const newTime = new Date().getTime()
        const registrationEndTime = new Date(item.examStartTime).getTime() - item.cutoffDays*(24*3600*1000)
        if(newTime>registrationEndTime){
          this.$message.warning('已经错过本次考试报名截止时间，请下次考试在报名！')
          return false
        }
        this.appointmentTypeArr = []
        if(item.isLogin){//判断是否报过考试，报过调用info接口
          this.$store.dispatch('ExamInfo', {id:item.id}).then(res=>{
            if(res.data.code == 0){
              
              this.formObj = res.data.sysAppointmentExamMain
              this.formObj.feeType = String(this.formObj.feeType)
              this.formObj.agentLevel = String(this.formObj.agentLevel)
              this.formObj.appointmentType = String(this.formObj.appointmentType)
              this.formObj.certificateType = String(this.formObj.certificateType)
              let typeArrLength=item.appointmentType.split(',')
              for(let i=0;i<typeArrLength.length;i++){
                let typeObj = {}
                if(typeArrLength[i] == 0){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'销售'
                  }
                }else if(typeArrLength[i] == 1){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'代理商'
                  }
                }else if(typeArrLength[i] == 2){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'员工'
                  }
                }else{
                   typeObj = {
                    value:typeArrLength[i],
                    text:'个人'
                  }
                }
                this.appointmentTypeArr.push(typeObj)
              }
              this.queryCity(this.formObj.province)
              this.provinceStr = this.formObj.province
              this.visible = true
              // console.log(res);
            }else{
              this.$message.error(res)
            }
            this.getAttachmentCode()
          }).catch(err=>{
            this.$message.error(err)
          })
        }else{
          console.log(item);
          let typeArrLength=item.appointmentType.split(',')
              for(let i=0;i<typeArrLength.length;i++){
                let typeObj = {}
                if(typeArrLength[i] == 0){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'销售'
                  }
                }else if(typeArrLength[i] == 1){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'代理商'
                  }
                }else if(typeArrLength[i] == 2){
                  typeObj = {
                    value:typeArrLength[i],
                    text:'员工'
                  }
                }else{
                   typeObj = {
                    value:typeArrLength[i],
                    text:'个人'
                  }
                }
                this.appointmentTypeArr.push(typeObj)
              }
          this.visible = true;
          this.temp()
          this.formObj.examId = item.id
          this.formObj.appointmentType = this.appointmentTypeArr[0].value
          this.formObj.fileId=''
          this.fileList=[]
          this.getAttachmentCode()
        }
      }
    },
    //获取省份
    async queryProvince(){
        await this.$store.dispatch('QueryProvince').then(res=>{
            if(res.data.code == 0){
                this.provinceData = res.data.data
                this.provinceStr = res.data.data.[0].provinceId
            }else{
                this.$message.error(res.data.msg);
            }
        }).catch(err=>{
            this.$message.error(err);
        })
    },
    // 获取城市
    async queryCity(id){
        let provinceIdStr = id
        await this.$store.dispatch('QueryCity',{provinceId:id}).then(res=>{
            if(res.data.code == 0){
                this.cityData = {[provinceIdStr]:res.data.data}
                console.log('1111111111',this.cityData);
            }else{
                this.$message.error(res.data.msg);
            }
        }).catch(err=>{
            this.$message.error(err);
        })
    },
    // 下载模板
    downFile(){
        this.btnLoading=true
        this.$store
        .dispatch("DownloadAction")
        .then(res => {
          if (res) {
            //判断res
            //判断res.data
            console.log(res.headers);
            const content = res.data ? res.data : res;
            const blob = new Blob([content]);
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = '学员认证考试报名表模板.xls'
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
              this.btnLoading=false
            } else {
                this.btnLoading=false
              // IE10+下载
              navigator.msSaveBlob(blob, "学员认证考试报名表模板.xls");
            }
          } else {
              this.btnLoading=false
            this.$message.error("下载失败，请重试");
          }
        })
        .catch(err => {
            this.btnLoading=false
          this.$message.error(err);
        });
    },
    // 获取下载code
    getAttachmentCode(){
      this.$store.dispatch('GetAttachmentCode').then(res=>{
        if(res.status==200){
          this.fileCode = res.data
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 上传 zip
 customRequestZip(data){
   this.loadingBtnFile=true
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("attachmentCode", this.fileCode);
  formData.append("readType", "public");
  // 获取用户信息，将用户id写在里边
  formData.append('userId','15')
  // formData.append("token", "aiufpaidfupipiu"); //随便写一个token示例
  this.$store.dispatch("UploadFileAction", formData)
    .then((res) => {
      if (res.data.code == 0) {
        this.loadingBtnFile=false
        data.file.fileId = res.data.data.id
        this.formObj.fileId = res.data.data.id
        this.fileList=[data.file]

      } else {
        this.$message.error("上传失败");
        this.loadingBtnFile=false
      }
    })
    .catch((err) => {
      this.loadingBtnFile=false
      throw new Error(err);
    });
},
// 文件上传前的格式验证 zip
 beforeUploadZip(file){
  const uploadSize = file.size / 1024 / 1024 < 50;
  const uploadType = file.name.substring(file.name.lastIndexOf(".") + 1);
  if (this.acceptTypeEquipZip.length > 0 && this.acceptTypeEquipZip.indexOf(uploadType) === -1) {
    this.$message.error("导入文件只能是" + this.acceptTypeEquipZip.join("、") + "格式!");
    return false;
  }
  if (!uploadSize) {
    this.$message.error("上传文件大小不能超过 50MB!");
    return false;
  }
  this.fileImgList = [...this.fileImgList, file];
},
// 删除上传文件
 removeFile(file){
  this.removeAttach(this.fileList[0]);
},
 removeAttach(data){
  if (!data.id) {
    this.fileList.splice(this.fileList.length - 1, 1);
    return;
  }
},
  },
  components: {},
  filters: {},
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
